export default "__VITE_ASSET__8MoI7s6b__"